import {createAction} from 'redux-act'

export const setGoalPlanModalVisible = createAction('SET_GOAL_PLAN_MODAL_VISIBLE')
export const setGoalPlanForm = createAction('SET_GOAL_PLAN_FORM')
export const closeGoalPlanForm = createAction('CLOSE_GOAL_PLAN_FORM')


